// extracted by mini-css-extract-plugin
export default {"list":"CategoriesList_list__yh8Ib","simple-bar":"CategoriesList_simple-bar__hFEs2"};